import React, { Component, Fragment } from "react";
import LoginTabset from "./loginTabset";
import "./login.css";
import { connect } from "react-redux";
import { Anchor, Send, Truck } from "react-feather";
import ArshipperLogo from "../../assets/brand/arshipper-logo.png";

// Inline rather than emoji: Windows has no flag-emoji font and renders 🇨🇳/🇧🇩
// as the bare letters "CN"/"BD". At 15px the PRC's stars can't be drawn as
// stars, so they are dots — a deliberate simplification at this size.
const FLAGS = {
  cn: (
    <svg className="ars-flag" viewBox="0 0 30 20" aria-hidden="true">
      <rect width="30" height="20" rx="2.5" fill="#de2910" />
      <path
        fill="#ffde00"
        d="M8 3.4 9.4 7.6 13.6 7.6 10.2 10.2 11.5 14.4 8 11.8 4.5 14.4 5.8 10.2 2.4 7.6 6.6 7.6Z"
      />
    </svg>
  ),
  bd: (
    <svg className="ars-flag" viewBox="0 0 30 20" aria-hidden="true">
      <rect width="30" height="20" rx="2.5" fill="#006a4e" />
      <circle cx="13.5" cy="10" r="6" fill="#f42a41" />
    </svg>
  ),
};

// The three corridors arshipper actually runs, shown as a compact live
// tracker in the card's green column. Deliberately no transit times: they
// change per lot, and a login screen is the wrong place to state a number
// nobody can act on.
const LANES = [
  {
    code: "SEA",
    from: "Guangzhou",
    fromFlag: "cn",
    to: "Dhaka",
    toFlag: "bd",
    Vehicle: Anchor,
  },
  {
    code: "AIR",
    from: "Guangzhou",
    fromFlag: "cn",
    to: "Dhaka",
    toFlag: "bd",
    Vehicle: Send,
  },
  {
    code: "D2D",
    from: "Dhaka",
    fromFlag: "bd",
    to: "Doorstep",
    toFlag: "bd",
    Vehicle: Truck,
  },
];

export class Login extends Component {
  render() {
    return (
      <Fragment>
        <div className="ars-login-page">
          <main className="ars-stage">
            <div className="ars-card-frame">
              <div className="ars-card">
                {/* left column — the tracker, on the brand gradient */}
                <aside className="ars-tracker">
                  <img
                    className="ars-wordmark"
                    src={ArshipperLogo}
                    alt="arshipper"
                  />

                  <div className="ars-tracker-body">
                    <div>
                      <h1 className="ars-headline">
                        Every parcel, always moving forward.
                      </h1>
                      <p className="ars-subcopy">
                        Sea freight, air freight, sourcing and door-to-door
                        delivery for importers across Bangladesh.
                      </p>
                    </div>

                    <div className="ars-lane-group">
                      <span className="ars-lanes-label">Live corridors</span>
                      <ul className="ars-lanes">
                      {LANES.map(
                        (
                          { code, from, fromFlag, to, toFlag, Vehicle },
                          i,
                        ) => (
                          <li
                            className="ars-lane"
                            key={code}
                            style={{ "--lane-index": i }}
                          >
                            <span className="ars-lane-code">{code}</span>
                            <span className="ars-endpoint">
                              {FLAGS[fromFlag]}
                              <b>{from}</b>
                            </span>
                            <span className="ars-route">
                              <span className="ars-route-track" />
                              <span className="ars-route-vehicle">
                                <Vehicle />
                              </span>
                            </span>
                            <span className="ars-endpoint is-to">
                              <b>{to}</b>
                              {FLAGS[toFlag]}
                            </span>
                          </li>
                        ),
                      )}
                      </ul>
                    </div>
                  </div>

                  <p className="ars-tracker-foot">
                    Moving Bangladesh&apos;s imports, one shipment at a time.
                  </p>
                </aside>

                {/* right column — the form */}
                <section className="ars-form-col">
                  <header className="ars-form-head">
                    <span className="ars-form-eyebrow">
                      Staff &amp; partner access
                    </span>
                    <h2 className="ars-form-title">Sign in</h2>
                    <p className="ars-form-sub">
                      Use your arshipper account to reach the shipment control
                      desk.
                    </p>
                  </header>

                  <LoginTabset
                    setCurrentAdmin={this.props.setCurrentAdmin}
                    currentAdmin={this.props.currentAdmin}
                  />
                </section>
              </div>
            </div>

            <p className="ars-page-foot">
              © {new Date().getFullYear()} arshipper
            </p>
          </main>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentAdmin: state.admins.currentAdmin,
  };
};
export default connect(mapStateToProps)(Login);
